import Modal from "../../ui-components/Modal";
import {
  ArrowRightCircleIcon,
  ArrowLeftCircleIcon,
} from "@heroicons/react/24/outline";
import PrivateImage from "../PrivateImage";

function WorksiteImageModal({closeModal, image, onNextImage, onPrevImage}) {
  const {image_url, des_image} = image;

  return (
    <Modal onExit={closeModal}>
      <div className="flex w-full flex-col h-full items-center justify-center">
        <div className="w-full mb-4 flex justify-center">
          <PrivateImage
            image_url={image_url}
            tag={'img'}
            fixedAspectRatio={false}
          />
        </div>
        <p>{des_image}</p>
        <div className="w-full flex justify-around mt-4">
          <div className="w-10 h-10 cursor-pointer" onClick={onPrevImage}>
            <ArrowLeftCircleIcon/>
          </div>
          <div className="w-10 h-10 cursor-pointer" onClick={onNextImage}>
            <ArrowRightCircleIcon/>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default WorksiteImageModal;
